import {createTooltipTranslationProviderFromNamespace} from 'features/localizedTooltips';

export const CompareVersionFormTooltipTranslationProvider =
	createTooltipTranslationProviderFromNamespace(
		'features/RegDocs/compareVersionForm',
	);
